import { render, staticRenderFns } from "./QuotationIconButton.vue?vue&type=template&id=8eb9ec5a"
import script from "./QuotationIconButton.vue?vue&type=script&lang=js"
export * from "./QuotationIconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports